'use client';

import type { CommunityChannel } from '../../types/CommunityChannel';
import type { ExtendedCommunityChannelMessage } from '../../types/ExtendedCommunityChannelMessage';
import { ChannelMessageBubble } from '../channel-message-view/ChannelMessageBubble';

interface Props {
  channel: CommunityChannel;
  /** The message snapshot embedded on the bookmark doc. */
  message: ExtendedCommunityChannelMessage;
  currentUserId: string | null | undefined;
}

/**
 * One row in the Bookmarks panel — renders the bookmark's embedded message
 * snapshot as a regular bubble (reactions, inline replies, and the kebab all
 * work). Rendering the snapshot directly (no per-row fetch) means bookmarks
 * appear instantly, like upstream. `preserveWhenGone` keeps a since-deleted
 * message visible as the standard "This message has been deleted." placeholder
 * instead of dropping the row.
 */
export function BookmarkedMessageRow({
  channel,
  message,
  currentUserId,
}: Props) {
  return (
    <ChannelMessageBubble
      message={message}
      currentUserId={currentUserId}
      channelSlug={channel.slug}
      repliesMode="inline"
      preserveWhenGone
    />
  );
}
